const Ticket = () => {
  const data = [
    {
      Subject: "Order is not delivered",
      Submitted: "May 21, 2021",
      type: "Delivered",
      Priority: "High",
      Status: "Open",
    },
    {
      Subject: "Order is not delivered",
      Submitted: "May 21, 2021",
      type: "Delivered",
      Priority: "High",
      Status: "Open",
    },
    {
      Subject: "Order is not delivered",
      Submitted: "May 21, 2021",
      type: "Delivered",
      Priority: "High",
      Status: "Open",
    },
  ];

  return (
    <div className="w-full">
      <div className="p-5 w-full bg-gray-200">
        {/* Mobile */}
        <div className="flex  justify-center items-center flex-col md:hidden">
          <h1 className="font-bold text-lg">Tickets</h1>
          <div className="text-sm text-gray-600 flex justify-center items-center gap-3">
            <span className="cursor-pointer">Home</span>/<span>Account</span>
          </div>
        </div>

        {/* Laptop */}
        <div className="hidden md:flex justify-between items-center">
          <h1 className="font-bold text-lg">Order</h1>
          <div className="text-sm text-gray-600 flex justify-end gap-2">
            <span className="cursor-pointer">Home</span>/<span>Account</span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto w-full p-5">
        {/* Desktop Table */}
<div className="overflow-x-auto w-full p-5 hidden md:block">
  <table className="min-w-full border border-collapse border-gray-300 text-sm">
    <thead className="bg-gray-100">
      <tr>
        <th className="px-5 py-3 font-medium border-b">Ticket Subject</th>
        <th className="px-5 py-3 font-medium border-b">Date Submitted</th>
        <th className="px-5 py-3 font-medium border-b">Type</th>
        <th className="px-5 py-3 font-medium border-b">Priority</th>
        <th className="px-5 py-3 font-medium border-b">Status</th>
      </tr>
    </thead>
    <tbody>
      {data.map((tic, index) => (
        <tr key={index} className="text-center">
          <td className="px-5 py-3 border-b">{tic.Subject}</td>
          <td className="px-5 py-3 border-b">{tic.Submitted}</td>
          <td className="px-5 py-3 border-b">{tic.type}</td>
          <td className="px-5 py-3 border-b">
            <span className="bg-primary text-white px-2 py-1 rounded-md">
              {tic.Priority}
            </span>
          </td>
          <td className="px-5 py-3 border-b">
            <span className="bg-green-600 text-white px-2 py-1 rounded-md">
              {tic.Status}
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

{/* Mobile Card View */}
<div className="w-full p-5 space-y-4 md:hidden">
  {data.map((tic, index) => (
    <div key={index} className="border rounded-md shadow-sm p-4 bg-white">
      <div className="mb-2">
        <span className="font-semibold">Subject:</span> {tic.Subject}
      </div>
      <div className="mb-2">
        <span className="font-semibold">Submitted:</span> {tic.Submitted}
      </div>
      <div className="mb-2">
        <span className="font-semibold">Type:</span> {tic.type}
      </div>
      <div className="mb-2">
        <span className="font-semibold">Priority:</span>{" "}
        <span className="bg-primary text-white px-2 py-1 rounded-md">
          {tic.Priority}
        </span>
      </div>
      <div>
        <span className="font-semibold">Status:</span>{" "}
        <span className="bg-green-600 text-white px-2 py-1 rounded-md">
          {tic.Status}
        </span>
      </div>
    </div>
  ))}
</div>

      </div>
    </div>
  );
};

export default Ticket;
